import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    areaList: [],
    menuTree: [],
    areaLists: [],
    areaListArr: [],
  },
  mutations: {
    setAreaLsit(state, val) {
      state.areaList = val
    },
    setMenuTree(state, val) {
      state.menuTree = val
    },
    setAreaLists(state, val) {
      state.areaLists = val
    },
    setAreaListArr(state, val) {
      state.areaListArr = val
    },
  },
  getters: {
    getAreaLsit(state) {
      return state.areaList
    },
    getAreaLists(state) {
      return state.areaLists
    },
    getAreaListArr(state) {
      return state.areaListArr
    },
    // 首页菜单
    getMenuTreeIndex(state) {
      if (state.menuTree[0] && state.menuTree[0].children)
        return state.menuTree[0].children.filter(res => res.id == '3d072a61118b461c9028e2546959ada9')[0].children
    },
    // 获取总菜单
    getSubMenuTree(state) {
      return state.menuTree
    },
  },
  actions: {},
  modules: {}
});
